import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class AuthenticatedCareerPathwaysIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    // Redirect /reimagined to /reimagined/home
    this.router.replaceWith('authenticated.reimagined.home');
  }
}
